export default "__VITE_ASSET__Ahauvgea__"